<template>
  <div class="c-account-box">
    <div class="c-header">
      <Checkbox class="c-check-item" v-model="all" :indeterminate="indeter" :disabled="disabled" v-if="extend">全选</Checkbox>
      <span>{{ title }}</span>
      <div class="c-cataract" @click.stop="selectAll" v-if="extend"></div>
    </div>
    <div class="c-search" :class="{ 'm-disabled': disabled }">
      <Input v-model="keyword" placeholder="" clearable search :disabled="disabled" />
    </div>
    <div class="c-content">
      <Spin size="large" fix v-if="loading"></Spin>
      <slot></slot>
    </div>
  </div>
</template>
<script>
export default {
  name: 'accountBox',
  props: {
    title: {
      type: String
    },
    data: {
      type: Array
    },
    level: {
      type: Number
    },
    value: {
      type: String
    },
    loading: {
      type: Boolean
    },
    disabled: {
      type: Boolean,
      default() {
        return false
      }
    }
  },
  computed: {
    all() {
      const len = this.data.filter((ret) => ret.check).length
      return this.data.length === len
    },
    extend() {
      return Boolean(this.data.length) && this.level > 2
    },
    indeter() {
      return this.data.some((ret) => ret.check) && !this.data.every((ret) => ret.check)
    },
    keyword: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    }
  },
  methods: {
    selectAll() {
      this.$emit('on-select', {
        check: !this.all,
        level: this.level,
        keyword: this.keyword
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.c-account-box {
  background-color: #fff;

  .c-header {
    padding: 0 12px;
    height: 34px;
    font-size: 14px;
    color: #333;
    border-bottom: 1px solid #e8eaec;
    background-color: #f8f8f8;
    position: relative;

    span {
      line-height: 34px;
      vertical-align: middle;
    }

    .c-check-item {
      float: right;
      margin-right: 0;
      margin-top: 9px;
    }

    .c-cataract {
      position: absolute;
      width: 42px;
      height: 34px;
      top: 0;
      right: 12px;
      z-index: 8;
      cursor: pointer;
    }
  }

  .c-search {
    width: 100%;
    padding: 8px 12px;
    background-color: #fff;
  }

  .c-content {
    overflow-y: auto;
    scrollbar-width: thin;
    -webkit-overflow-scrolling: touch;
    position: relative;
    height: 368px;
    width: 100%;
    padding-bottom: 8px;
  }
}

/* 半选状态 */
::v-deep .ivu-checkbox-indeterminate {
  .ivu-checkbox-inner {
    background-color: #6fb3fb;
    border-color: #6fb3fb;
  }
}
</style>
